import React, { useEffect, useRef } from 'react'
import "./About.css"
import { profile2 } from '../../images'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { FaGooglePlay, FaGlobe, FaTelegram } from 'react-icons/fa'

// Register GSAP plugin at module level
gsap.registerPlugin(ScrollTrigger);

const About = () => {
  const container = useRef(null);

  useEffect(() => {
    const el = container.current;
    gsap.fromTo('.about__container', {
      scale: 0.7,
    },
      {
        scale: 1,
        scrollTrigger: {
          trigger: el,
          scrub: true,
          markers: false,
        }
      })
  }, [])

  return (
    <section ref={container} id='about'>
      <div className="section__wrapper about__container">
        <div className="me__container blur-effect">
          <div className="photo__container">
            <img src={profile2} alt="Ragnar" />
          </div>
        </div>
        <div className="about__content">
          <div className="section__header">
            <h4 className='primary__title'>ABOUT ME</h4>
            <h1 className='title'>I am <span className='color__primary'>Ragnar</span></h1>
          </div>
          <p className="text__muted description about__bio">
            I'm a passionate developer who builds mobile apps, web platforms, and Telegram communities.
            With multiple apps published on the Google Play Store and an active web service used by thousands,
            I focus on creating tools that solve real problems — from network diagnostics to privacy-focused
            email solutions.
          </p>
          <p className="text__muted description about__bio">
            Beyond development, I run the Ragnar Servers Telegram community where I share tech resources,
            configuration files, and premium service giveaways with a growing audience of tech enthusiasts.
          </p>

          <div className="about__stats">
            <div className="about__stat">
              <FaGooglePlay className="about__stat-icon" />
              <div>
                <h3>5</h3>
                <span className="text__muted">Play Store Apps</span>
              </div>
            </div>
            <div className="about__stat">
              <FaGlobe className="about__stat-icon" />
              <div>
                <h3>2</h3>
                <span className="text__muted">Live Websites</span>
              </div>
            </div>
            <div className="about__stat">
              <FaTelegram className="about__stat-icon" />
              <div>
                <h3>11K+</h3>
                <span className="text__muted">Community Members</span>
              </div>
            </div>
          </div>

          <a href="https://telegram.me/Not_Ragnar" target="_blank" rel="noreferrer" className="btn btn__primary">Let's Connect</a>
        </div>
      </div>
    </section>
  )
}

export default About
